import {
    Box,
    HStack,
    Flex,
    Text,
    Menu,
    MenuButton,
    MenuItem,
    VStack,
    useBreakpointValue,
    MenuList,
    IconButton,
} from '@chakra-ui/react'
import React from 'react'
import { ToastContainer } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';
import SideBar from './SideBar';
import { useAuth } from '../../providers/AuthProvider';
import { FaDatabase, FaQrcode } from 'react-icons/fa';
import { Link } from 'react-router-dom';

export default function Navbar() {
    const { user } = useAuth();
    const sideBarVariant = useBreakpointValue({ base: 'drawer', md: 'sidebar' });

    return (
        <>
            <Box
                bg='primary.800'
                px={3}
                w='100%'
                h='8.5vh'
            >
                <Flex h='100%' alignItems={'center'} justifyContent={'space-between'}>

                    {sideBarVariant === 'drawer' && (
                        <SideBar />
                    )}

                    <Flex
                        w='100%'
                        bg='primary.800'
                    >
                        <VStack justifyContent='center' w='100%' alignItems='center' spacing='0'>
                            <Link to='/'>
                                <img src='/logo-white.png' style={{ width: '126px' }} />
                            </Link>
                            {/* <Text className='customFont' fontSize='md' color='#fefefe'>Welcome <span color='#fefefe'>{user.Name}</span></Text> */}
                        </VStack>


                        <HStack
                            justifyContent='center'
                            alignItems='center'
                            spacing='2'
                        >
                            <IconButton
                                icon={<FaDatabase color='white' />}
                                variant='ghost'
                                _hover={{
                                    bg: 'primary.800'
                                }}
                                bg='primary.800'
                            />
                            <IconButton
                                as={Link}
                                to='/scan'
                                variant='ghost'
                                _hover={{
                                    bg: 'primary.800'
                                }}
                                bg='primary.800'
                                icon={<FaQrcode color='white' />}
                            />
                        </HStack>

                    </Flex>
                </Flex>

            </Box >
            <ToastContainer />
        </>
    )
} 